import React from "react";

export const initialModal = () => ({
  title: "Instructions",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        Welcome to <strong>The Reflex Challenge!</strong>
      </div>
      <div className="modal-description-contents">
        <p>
          When the game starts, wait patiently. One of the boxes will turn
          <span className="highlight-green"> GREEN</span> — you must click it
          within <strong>0.6 seconds</strong> to move to the next round.
        </p>
        <p>
          But beware: some boxes may flash
          <span className="highlight-yellow"> YELLOW</span> to trick you. Don’t
          click too early or on the wrong one. There are 5 levels, and each one
          gets harder.
        </p>
      </div>
      <div className="modal-description-footer">Can you beat them all?</div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});

export const levelPassedModal = (reactionTime, level) => ({
  title: "Level Passed!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          Nice reflexes! Your reaction time was{" "}
          <span className="highlight-blue">{reactionTime.toFixed(2)}s</span>.
          Get ready for Level {level + 1}.
        </p>
      </div>
    </div>
  ),
  buttonText: level < 5 ? "Next" : "Start",
  buttonType: "start",
});

export const championModal = (reactionTime) => ({
  title: "Reflex Champion!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          Amazing! Final level reaction time:{" "}
          <span className="highlight-blue">{reactionTime.toFixed(2)}s</span>.
          You've conquered all 5 levels.
        </p>
      </div>
    </div>
  ),
  buttonText: "Play Again",
  buttonType: "start",
});

export const failEarlyModal = () => ({
  title: "Too Early!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          You clicked before the box turned{" "}
          <span className="highlight-green">GREEN</span>. Patience is part of
          the challenge!
        </p>
      </div>
    </div>
  ),
  buttonText: "Retry",
  buttonType: "retry",
});

export const failSlowModal = (reactionTime) => ({
  title: "Too Slow!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          Your reaction time was{" "}
          <span className="highlight-blue">{reactionTime.toFixed(2)}s</span>.
          You need to click within <strong>0.6s</strong> to advance. Try to be
          quicker next time!
        </p>
      </div>
    </div>
  ),
  buttonText: "Retry",
  buttonType: "retry",
});

export const failWrongModal = () => ({
  title: "Wrong Box!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          Oops! That wasn't the <span className="highlight-green">GREEN</span>{" "}
          one. Stay focused and try again.
        </p>
      </div>
    </div>
  ),
  buttonText: "Retry",
  buttonType: "retry",
});
